/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard React base styles
import colors from "assets/theme/base/colors";
// Soft UI Dashboard React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { transparent } = colors;

const select = {
  styleOverrides: {
    select: {
      alignItems: "center",
      paddingRight: `${pxToRem(32)} !important`,
      cursor: "pointer",
      "& .Mui-selected": {
        backgroundColor: transparent.main,
      },
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    selectMenu: {
      height: "auto",
      minHeight: "auto",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    outlined: {
      paddingRight: `${pxToRem(32)} !important`,
    },
    filled: {
      paddingRight: `${pxToRem(32)} !important`,
    },
  },
};

export default select;
